import request from "@/utils/request";

export async function logSecurePassScanned(data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/media-service/secure-pass-log/qr-scanned`, {
    method: "POST",
    data,
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result;
}

export async function validateSecurePassCode(data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/secure-passes/verify-driver-code`, {
    method: "POST",
    data,
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result?.data;
}

export async function getSecurePass(shipmentId) {
  const result = await request(
    `${REACT_APP_API_BASE_URL_NEW}/api/core-service/secure-passes/by-shipment/${shipmentId}`,
    {
      method: "GET",
    },
  );

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result?.data;
}

export async function resendSecurePass(shipmentId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/secure-passes/resend/${shipmentId}`, {
    method: "POST",
    data: { shipmentId },
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result;
}

export async function overrideSecurePass(shipmentId, reason) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/secure-passes/by-pass/${shipmentId}`, {
    method: "PATCH",
    data: { reason },
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result;
}

export async function getSecurePassSummary(shipmentId) {
  const result = await request(
    `${REACT_APP_API_BASE_URL_NEW}/api/media-service/secure-pass-log/summary/${shipmentId}`,
    {
      method: "GET",
    },
  );

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result?.data;
}

export async function getSecurePassLogs({ page = 1, pageSize = 10, filter = "", securePassLogType }) {
  const pageNumber = page - 1;
  const skipCount = pageNumber * pageSize;

  const params = {
    FilterText: filter || undefined,
    SkipCount: skipCount,
    MaxResultCount: pageSize,
    Type: securePassLogType,
  };
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/media-service/secure-pass-log`, {
    method: "GET",
    params,
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result?.data;
}

export async function securePassOutreachAttempt(data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/media-service/secure-pass-log/outreach-attempt`, {
    method: "POST",
    data,
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result;
}
